import axios from 'axios'
import { Toast, Dialog } from 'vant'
let baseURL = process.env.NODE_ENV === 'development' ? 'http://192.168.0.108:10001/api' : 'https://api.zhifu88.cn/api'
interface Respone {
  status: number;
  data: any;
  message: string;
}

const authStorageKeys = [
  'token',
  'userId',
  'userInfo',
  'tenantId',
  'avatar',
  'follow'
]
let authResetting = false

const isMissingUserMessage = (message: any) => {
  const text = String(message || '')
  return text.indexOf('用户') > -1 && [
    '未查到',
    '未查询到',
    '未找到',
    '不存在'
  ].some(keyword => text.indexOf(keyword) > -1)
}

const resetWechatAuth = () => {
  if (authResetting) return
  authResetting = true
  authStorageKeys.forEach(key => localStorage.removeItem(key))
  Toast.clear()

  const url = new URL(window.location.href)
  url.searchParams.delete('code')
  url.searchParams.delete('state')
  // 公众号用户由首页统一发起 OAuth，不进入账号登录/注册页
  url.hash = '#/'
  window.location.replace(url.toString())
}

const pathMap = {
  baseUrl: baseURL,
  login: '/auth/jwt/member/token',
  refreshToken: '/auth/jwt/refresh',
  weChatLogin: '/auth/user/wechat/login',
  sendCode: '/mall/mobile/center/sendSms',
  loginCode: '/mall/mobile/center/login/verifyCode',
  loginWeChat: '/mall/mobile/center/login/wechat',
  loginout: '/mall/mobile/center/logOut',
  retrievePwd: '/api/mall/mobile/center/retrievePwd',
  userInfo: '/mall/mobile/member/info',
  getH5OpenId: '/mall/mobile/center/getWebOpenid',
  getMiniOpenId: '/mall/mobile/center/getMiniOpenid',
  register: '/mall/mobile/center/register',
  rodationList: '/mall/mobile/rotation/list',
  categoryTree: '/mall/mobile/category/tree',
  virtualTree:'/mall/mobile/virtual/category/tree',
  sortTree: '/mall/mobile/sort/tree',
  categoryBelow: '/mall/mobile/category/below',
  categoryRecomList: '/mall/mobile/category/recomList',
  productList: '/mall/mobile/product/list',
  virtualList:'/mall/mobile/virtual/product/list',
  productInfo: '/mall/mobile/product/info',
  virtualInfo:'/mall/mobile/virtual/product/info',
  productHotList: '/mall/mobile/product/hotList',
  productRecomList: '/mall/mobile/product/recomList',
  productActivityList: '/mall/mobile/product/activityList',
  cartList: '/mall/mobile/cart/list',
  cartDelete: '/mall/mobile/cart/delete',
  cartQuantity: '/mall/mobile/cart/quantity',
  cartSelected: '/mall/mobile/cart/selected',
  cartSelectedBatch: '/mall/mobile/cart/selected/batch',
  cartAdd: '/mall/mobile/cart/save',
  cartClear: '/mall/mobile/cart/clear',
  collectList: '/mall/mobile/collect/list',
  collectSave: '/mall/mobile/collect/save',
  collectStoreUp: '/mall/mobile/collect/storeUp',
  footMarkList: '/mall/mobile/footMark/list',
  addressList: '/mall/mobile/address/list',
  addressDefault: '/mall/mobile/address/default',
  addressSave: '/mall/mobile/address/save',
  addressDelete: '/mall/mobile/address/delete',
  addressDetail:'/mall/mobile/address/findById',
  pointLog: '/mall/mobile/member/pointList',
  balanceList:'/mall/mobile/member/balanceList',
  orderList: '/mall/mobile/order/list',
  orderStatusNum: '/mall/mobile/order/statusNum',
  orderPre: '/mall/mobile/order/pre',
  orderSubmit: '/mall/mobile/order/submit',
  orderInfo: '/mall/mobile/order/info/',
  orderOff:'/mall/mobile/order/off',
  orderDeleted: '/mall/mobile/order/deleted',
  orderCancel: '/mall/mobile/order/cancel',
  uploadCenterToken: '/mall/mobile/uploadCenter/uploadCoverToken',
  userSave: '/mall/mobile/member/save',
  wechatShare: '/mall/mobile/center/wechat/share',
  turntableInfo: '/mall/mobile/turntable/info',
  turntableGenerateAward: '/mall/mobile/turntable/generateAward',
  turntableCountCanUse: '/mall/mobile/turntable/countCanUse',
  turntableList: '/mall/mobile/turntable/list',
  activityFullGiftLotteryInfo: '/mall/mobile/activity/fullGift/lottery/info',
  orgInfo: '/mall/mobile/org/info',
  courseList: '/mall/mobile/course/list',
  courseInfo: '/mall/mobile/course/info/',
  liveList: '/mall/mobile/live/list',
  liveInfo: '/mall/mobile/live/info/',
  orderCoursePre: '/mall/mobile/order/course/pre',
  virtualPre:'/mall/mobile/order/virtual/pre',
  orderCoudseSubmit: '/mall/mobile/order/course/submit',
  virtualOrderSubmit:'/mall/mobile/order/virtual/submit',
  ordercourseAndLiveList: '/mall/mobile/order/courseAndLive/list',
  orderVirtualList: '/mall/mobile/order/virtual/list',
  upload: '/mall/mobile/member/upload',
  wxUpload: '/mall/mobile/wx/upload',
  wxConfig: '/mall/mobile/wx/config',
  orderLivePre: '/mall/mobile/order/live/pre',
  orderLiveSubmit: '/mall/mobile/order/live/submit',
  orderLiveCancel: '/mall/mobile/order/live/cancel/',
  liveSignUp: '/mall/mobile/live/signUp',
  liveGetWxACode: '/mall/mobile/live/getwxacode/',
  myLiveList: '/mall/mobile/live/myList',
  createQRCode: '/mall/mobile/wx/createQRCode/',
  bindPhone: '/mall/mobile/member/bandingPhone',
  bindingVcode: '/mall/mobile/sms/bandingVcode',
  forgetVcode:'/mall/mobile/sms/forgeVcode',
  orderPay: '/mall/mobile/order/pay',
  orderBalancePay: '/mall/mobile/order/balancePay',
  orderPrice: '/mall/mobile/order/price/',
  wxPreview: '/mall/mobile/wx/preview/',
  wxCourseList: '/mall/mobile/wx/course/list',
  refreshWxCourseList: '/mall/mobile/course/courses',
  wxLiveList: '/mall/mobile/wx/live/list',
  refreshWxLiveList: '/mall/mobile/live/lives',
  wxProductList: '/mall/mobile/wx/product/list',
  refreshWxProductList: '/mall/mobile/product/products',
  wxJsSdk: '/mall/mobile/wx/share',
  couponReceiveList: '/mall/mobile/coupon/receiveList',
  couponOwnList: '/mall/mobile/coupon/ownList',
  couponReceive: '/mall/mobile/coupon/receive/',
  cardLogs: '/mall/mobile/shoppingCard/logs',
  cardList: '/mall/mobile/shoppingCard/list',
  orderRefund:'/mall/mobile/order/apply/refund',
  appraiseComment:'/mall/mobile/comment/save',
  CancelRefund:'/mall/mobile/order/unApply/refund',
  confirmReceipt:'/mall/mobile/order/confirm',
  appraiseDetail:'/mall/backend/comment/findAll',
  logistics:'/mall/mobile/order/logistics',
  deleteCart:'/mall/mobile/cart/deleteBatch',
  getPhone:'/mall/mobile/product/tel',
  deposit:'/mall/mobile/deposit/findAll',
  memberDeposit:'/mall/mobile/member/deposit',
  checkPassword:'/mall/mobile/member/check/password',
  updatePassword:'/mall/mobile/member/password/update',
  verifyPhoneCode:'/mall/mobile/member/verifyPhoneCode',
  subordinateUser:'/mall/mobile/member/subordinateUser',
  createQrCode:'/mall/mobile/member/createQrCode',
  WeuserInfo:'/mall/mobile/wechat/userInfo',
  addBankCard:'/mall/mobile/bank/save',
  bankCardList:'/mall/mobile/bank/list',
  withDrawSave:'/mall/mobile/withDraw/save',
  withDrawList:'/mall/mobile/withDraw/findByPage',
  commissionRecord:'/mall/mobile/commissionRecord/findByPage',
  deleteBankCard:'/mall/mobile/bank/delete',
  customerList:'/mall/mobile/order/my/customer/list',
  bankTypeList:'/mall/mobile/bank/type/list',
  virtualStatusNum:'/mall/mobile/order/virtual/statusNum'
}
const request = (path: string, method = 'get', params = {}) => {
  return new Promise<Respone>((resolve, reject) => {
    Toast.loading({
      message: '加载中...',
      forbidClick: true
    })
    const token = localStorage.getItem('token')
    let promise = null
    axios.defaults.headers = { Authorization: token}
    // axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
    for (let key in params) {
      if ((params[key] != 0 && !params[key] && isNaN(params[key])) || params[key] == undefined) {
        delete params[key]
      }
    }
    if (method === 'get') {
      promise = axios.get(baseURL + path, { params })
    } else {
      promise = axios.post(baseURL + path, params)
    }
    promise.then(res => {
      if (res.status === 200) {
        if (res.data.code === 200) {
          Toast.clear()
          resolve(res.data)
        }else if (res.data.code === 500) {
          Toast.clear()
          if (isMissingUserMessage(res.data.message)) {
            resetWechatAuth()
            reject(res.data)
            return
          }
          Dialog.alert({
            title: '提示',
            message: res.data.message
          })
          reject(res.data)
        } else {
          Dialog.alert({
            title: '提示',
            message: res.data.status
          })
        }
      }
    }).catch(err => {
      const errorData = err.response && err.response.data
        ? err.response.data
        : {}
      const { code, message } = errorData
      if (isMissingUserMessage(message)) {
        resetWechatAuth()
        reject(errorData)
        return
      }
      if ([40101, 40301, 40001].indexOf(code) > -1) {
        resetWechatAuth()
        reject(errorData)
      } else {
        Toast.clear()
        // Dialog.alert({
        //   title: '网络异常',
        //   message: path + ':' + JSON.stringify(err)
        // })
        reject(err)
      }
     
    })
  })
}

const upload = (file: File) => {
  const token = localStorage.getItem('token')
  const uploadUrl = baseURL + pathMap.upload
  return new Promise((resolve, reject) => {
    Toast.loading({
      message: '上传中...',
      forbidClick: true
    })
    const forms = new FormData()
    forms.append('file', file)
    axios.defaults.headers = { Authorization: token, 'Content-Type': 'multipart/form-data' }
    axios.post(uploadUrl, forms).then(res => {
      Toast.clear()
      if (res.status === 200) {
        resolve(res.data)
      } else {
        Toast('上传失败')
      }
    }).catch(err => {
      Toast.clear()
      Toast('网络请求失败')
      reject(err)
    })
  })
}

const wxUpload = (file: File, fileName: string) => {
  const token = localStorage.getItem('token')
  const uploadUrl = baseURL + pathMap.wxUpload
  return new Promise((resolve, reject) => {
    Toast.loading({
      message: '上传中...',
      forbidClick: true
    })
    const forms = new FormData()
    forms.append('file', file, fileName)
    axios.defaults.headers = { Authorization: token, 'Content-Type': 'multipart/form-data' }
    axios.post(uploadUrl, forms).then(res => {
      Toast.clear()
      if (res.status === 200) {
        resolve(res.data)
      } else {
        Toast('上传失败')
      }
    }).catch(err => {
      Toast.clear()
      Toast('网络请求失败')
      reject(err)
    })
  })
}

const getJsSdkConfig = () => {
  return new Promise((resolve, reject) => {
    // let url = encodeURIComponent(location.href.split('#')[0])
    let url = location.href.split('#')[0]
    request(pathMap.wxJsSdk, 'post', { url }).then(res => {
      let config = res.data
      window.wx.config({
        // debug: process.env.NODE_ENV === 'development' ? true : false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        debug: false,
        appId: config.appId, // 必填，公众号的唯一标识
        timestamp: config.timestamp, // 必填，生成签名的时间戳
        nonceStr: config.nonceStr, // 必填，生成签名的随机串
        signature: config.sign,// 必填，签名，见附录1
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareWeibo',
          'hideOptionMenu',
          'chooseWXPay'
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      window.wx.ready(() => {
        resolve()
      })
      window.wx.error((err: any) => {
        console.log(JSON.stringify(err));
        // Dialog.alert({
        //   title: '微信jsSdk',
        //   message: JSON.stringify(err)
        // })
        reject(err)
      })
    }).catch(err => {
      reject(err)
    })
  })

}
export default {
  pathMap, request, upload, wxUpload, getJsSdkConfig
}
